import DialogContext from 'UI/DialogContext/DialogContext';

const DialogConsumer = DialogContext.Consumer;

export default DialogConsumer;